import { loadStripe } from '@stripe/stripe-js';

// Stripe configuration
const STRIPE_CONFIG = {
  // These will be set via environment variables
  PUBLISHABLE_KEY: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY,
  SECRET_KEY: import.meta.env.VITE_STRIPE_SECRET_KEY, // Only for development - should be server-side
  WEBHOOK_SECRET: import.meta.env.VITE_STRIPE_WEBHOOK_SECRET,
  
  // Stripe configuration options
  options: {
    stripeAccount: undefined, // For Connect accounts if needed
    locale: 'en',
  },
  
  // Price IDs for each subscription tier (to be set when creating products in Stripe)
  PRICE_IDS: {
    pro: {
      monthly: import.meta.env.VITE_STRIPE_PRO_MONTHLY_PRICE_ID,
      annual: import.meta.env.VITE_STRIPE_PRO_ANNUAL_PRICE_ID,
    },
    premium: {
      monthly: import.meta.env.VITE_STRIPE_PREMIUM_MONTHLY_PRICE_ID,
      annual: import.meta.env.VITE_STRIPE_PREMIUM_ANNUAL_PRICE_ID,
    },
    agency: {
      monthly: import.meta.env.VITE_STRIPE_AGENCY_MONTHLY_PRICE_ID,
      annual: import.meta.env.VITE_STRIPE_AGENCY_ANNUAL_PRICE_ID,
    },
  },
};

// Initialize Stripe
let stripePromise;

export const getStripe = () => {
  if (!stripePromise) {
    if (!STRIPE_CONFIG.PUBLISHABLE_KEY) {
      console.warn('Stripe publishable key not found. Please set VITE_STRIPE_PUBLISHABLE_KEY environment variable.');
      return null;
    }
    stripePromise = loadStripe(STRIPE_CONFIG.PUBLISHABLE_KEY, STRIPE_CONFIG.options);
  }
  return stripePromise;
};

// Get price ID for a specific plan and billing cycle
export const getPriceId = (tier, billingCycle = 'monthly') => {
  return STRIPE_CONFIG.PRICE_IDS[tier]?.[billingCycle];
};

// Validate Stripe configuration
export const validateStripeConfig = () => {
  const missingKeys = [];
  
  if (!STRIPE_CONFIG.PUBLISHABLE_KEY) {
    missingKeys.push('VITE_STRIPE_PUBLISHABLE_KEY');
  }
  
  // Check if price IDs are configured
  const plans = ['pro', 'premium', 'agency'];
  const cycles = ['monthly', 'annual'];
  
  plans.forEach(plan => {
    cycles.forEach(cycle => {
      if (!STRIPE_CONFIG.PRICE_IDS[plan]?.[cycle]) {
        missingKeys.push(`VITE_STRIPE_${plan.toUpperCase()}_${cycle.toUpperCase()}_PRICE_ID`);
      }
    });
  });
  
  return {
    isValid: missingKeys.length === 0,
    missingKeys,
  };
};

export { STRIPE_CONFIG };
export default getStripe;